//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

// import AirtableForm from '@motionelements/core/src/components/ui/airtable/AirtableForm.vue';
import NovaDynaForm from '@motionelements/core/src/components/ui/NovaDynaForm.vue';
// import notificationService from '@motionelements/core/src/services/notification.service.js';
import formUrl from '@motionelements/core/src/helpers/form-url.js';

export default {
  name: 'CorporatePage',
  head() {
    return {
      bodyAttrs: {
        // [] is nuxt specific, helps to unify all classes for bodyAttrs, without this each bodyAttrs will overwrite the previous ones
        class: ['header-transparent'],
      },
    };
  },
  components: {
    // AirtableForm,
    NovaDynaForm,
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    ComparisonTable: () => import('@/components/corporate/ComparisonTable.vue'),
    HomeFaqs: () => import('@/components/home-page/HomeFaqs.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
  },
  watch: {
    userCurrency: { // @toDo @Pavlo why we need to watch userCurrency and resend getPlans
      handler(toCurrencyCode) {
        if (toCurrencyCode) {
          this.$store.dispatch('subscription/getPlans');
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      userCurrency: 'user/currencyCode',
    }),
    hasInvoicing() {
      return ['ja', 'ko', 'zh-hant'].includes(this.$i18n.locale);
    },
    // isSupportedCountry() {
    //   return ['ja', 'ko', 'zh-hant'].includes(this.$i18n.locale);
    // },
    pageTitle() {
      return _.upperFirst(this.$t('phrase.team_plan'));
    },
    pageDescription() {
      return this.$t('corporate.page_subheading');
    },
    breadcrumbList() {
      return [
        {
          name: _.upperFirst(this.$t('phrase.team_plan')),
          link: this.$link('/corporate').fullPath(),
          active: true,
        },
      ];
    },
  },
  methods: {
    formUrl,
  },
};
